import script from "./StatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusView.vue?vue&type=script&setup=true&lang=js"

import "./StatusView.vue?vue&type=style&index=0&id=4307bc2e&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4307bc2e"]])

export default __exports__